/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IntervalTypeEnum } from './intervalTypeEnum';


export interface CreateFinMathRequest { 
    futureValue?: number | null;
    initialPayment?: number | null;
    interestFrequency: IntervalTypeEnum;
    monthlyPayment?: number | null;
    yearlyDuration?: number | null;
    rate?: number | null;
    monthlyPaymentFlaged?: number | null;
    yearlyDurationFlaged?: number | null;
    futureValueFlaged?: number | null;
    initialPaymentFlaged?: number | null;
    rateFlaged?: number | null;
}
export namespace CreateFinMathRequest {
}


